module.exports = __webpack_public_path__ + "img/easel.a28ae978.svg";